import type { InvalidateQueryFilters, QueryClient } from '@tanstack/react-query';

const swallow = () => null;

/**
 * Invalidates the matching queries so that a change made after their read began is read for
 * certain. TanStack Query joins a first read still out when a query holding no data is
 * invalidated, and that read's answer, which may predate the change, then lands as fresh
 * (query-core `query.ts` fetch, the same hazard `use-email-list-total.ts` works around). So a
 * first read still out is stopped and asked again, where someone still watches it.
 */
export function refreshQueries(queryClient: QueryClient, filters: InvalidateQueryFilters): void {
  queryClient.invalidateQueries(filters).catch(swallow);
  for (const query of queryClient.getQueryCache().findAll(filters)) {
    if (query.state.fetchStatus !== 'fetching' || query.state.data !== undefined) {
      continue;
    }
    query
      .cancel({ revert: true, silent: true })
      .then(async () => {
        if (query.getObserversCount() > 0) {
          await query.fetch();
        }
      })
      .catch(swallow);
  }
}
